import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { notificacao } from '../master-page/redux/notificacao';
import { Card, Table, Button, Drawer, Divider } from 'antd';
import FormRegistro from './FormRegistro';

export class Listar extends Component {
  static propTypes = {
    parametrosSistema: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    drawerVisible: false,
  }
  componentDidMount() {
    this.props.actions.listar({ order: 'Nome ASC' }, (action) => {});
  }

  showDrawerEditar = (registro) => {
    this.props.actions.buscarPorId(registro.Nome, (action) => {
      if (action === 'PARAMETROS_SISTEMA_BUSCAR_POR_ID_SUCCESS') {
        this.setState({ drawerVisible: true });
      }
    })
  }
  handleEditarSubmit = form => {
    form.validateFields((err, values) => {
      if (err) {
        console.log(err);
        return;
      }
      this.salvarRegistro({ ...this.props.parametrosSistema.registro, ...values });
    });
  }
  salvarRegistro = (registro) => {
      this.props.actions.editar(registro, (action) => {
        if (action === 'PARAMETROS_SISTEMA_EDITAR_SUCCESS') {
          notificacao('success', 'Registro Salvo');
          this.setState({ drawerVisible: false });
          this.props.actions.listar({ order: 'Nome ASC' });
        } else {
          notificacao('error', 'Falha ao salvar registro');
        }
      });
  }
  handleCancelarDrawer = () => {
    this.setState({ drawerVisible: false });
  }
  render() {
    const { parametrosSistema } = this.props;
    const colunas = [
      {
        title: 'Parâmetro',
        dataIndex: 'Nome',
        key: 'Nome'
      },
      {
        title: 'Valor',
        dataIndex: 'Valor',
        key: 'Valor'
      },
      {
        title: 'Descrição',
        dataIndex: 'Descricao',
        key: 'Descricao'
      },
      {
        title: '',
        dataIndex: '',
        key: 'x',
        render: (text, record) => (
          <span>
            <Button 
              size="small" onClick={() => this.showDrawerEditar(record)} 
              icon='edit' 
              loading={this.props.buscarPorIdPending}
              >
                Editar
            </Button>
          </span>
        )
      }
    ];

    const DrawerRegistro = () => {
      return (
        <React.Fragment>
          <Drawer
            title='Editar Parâmetro'
            visible={this.state.drawerVisible}
            placement="right"
            closable={false}
            onClose={() => { this.setState({ drawerVisible: false }) }}
            width={500}
          >
            <Card
              extra={
                <React.Fragment>
                  <Button
                    onClick={this.handleCancelarDrawer}
                    type="primary"
                    icon="rollback"
                    size="default"
                  >
                    Cancelar
                  </Button>
                  <Divider type='vertical' />
                  <Button onClick={() => this.formRef.props.onSubmit()} type="primary" icon="save">
                    Salvar
                  </Button>
                </React.Fragment>
              }
            >
              <FormRegistro submitForm={this.handleEditarSubmit} formRef={el => (this.formRef = el)} />
            </Card>
         </Drawer>
        </React.Fragment>
      );
    }

    return (
      <div className="parametros-sistema-listar">
        <Card
          title={<h2>Parâmetros Sistema</h2>}
        >
          <Table
            dataSource={parametrosSistema.registros}
            columns={colunas}
            rowKey={record => record.Nome}
            loading={parametrosSistema.listarPending}
            size='small'
            style={{ marginTop: "15pt" }}
          />
        </Card>
        <DrawerRegistro />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    parametrosSistema: state.parametrosSistema,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Listar);



// WEBPACK FOOTER //
// ./src/features/parametros-sistema/Listar.js